<!-- Training creation form -->
<section>
  <div class="container max-width-900">
    <div class="row">
      <div class="col-4"></div>
      <div class="col-4">
        <h3 class="text-center font-bold mb-5">
          <i class="pi pi-plus-circle" style="font-size: 1.5rem"></i>
          {{ "Create a training program" | translator }}
        </h3>
      </div>
      <div class="col-4 d-flex justify-content-end">
        <p-button
          icon="pi pi-times"
          (onClick)="reload()"
          styleClass="p-button-rounded p-button-danger"
        ></p-button>
      </div>

      <div class="">
        <div class="custom-bg-1">
          <div class="d-flex justify-content-between mx-3">
            <h3 class="text-center font-bold">{{ step.title }}</h3>
            <h3 class="step">{{ "a step" | translator }} : {{ step.value }}</h3>
          </div>
          <form
            [hidden]="step.value != 1"
            [formGroup]="createTrainingForm"
            (ngSubmit)="onSubmit()"
            novalidate
          >
            <div class="card-scroll">
              <div class="row">
                <div class="col-lg-12">
                  <label
                    class="block text-900 font-medium mb-2 font-bold"
                    for="title"
                    >{{ "the address" | translator }}</label
                  >
                  <input
                    type="text"
                    id="title"
                    placeholder="{{
                      'Please write the title of the training program'
                        | translator
                    }}"
                    formControlName="title"
                    pInputText
                    class="w-full mb-3"
                  />
                  <div
                    class="error"
                    *ngIf="
                      createTrainingForm.controls['title'].invalid &&
                      (createTrainingForm.controls['title'].dirty ||
                        createTrainingForm.controls['title'].touched)
                    "
                  >
                    <div
                      *ngIf="createTrainingForm.controls['title'].errors?.['required']"
                    >
                      {{ "The title is required" | translator }}
                    </div>
                    <!-- <div *ngIf="createTrainingForm.controls['title'].errors?.['pattern']">{{"Please write in Arabic"| translator}}</div> -->
                  </div>
                </div>

                <div class="col-lg-12">
                  <label
                    class="block text-900 font-medium mb-2 font-bold"
                    for="title"
                    >{{ "Type" | translator }} :
                    <strong>{{ data?.type?.arabic }}</strong></label
                  >
                </div>

                <div class="col-lg-12">
                  <label
                    class="block text-900 font-medium mb-2 font-bold"
                    for="description"
                    >{{ "the description" | translator }}</label
                  >
                  <p-editor
                    formControlName="description"
                    [style]="{ height: '320px' }"
                  >
                  </p-editor>
                  <div
                    class="error"
                    *ngIf="
                      createTrainingForm.controls['description'].invalid &&
                      (createTrainingForm.controls['description'].dirty ||
                        createTrainingForm.controls['description'].touched)
                    "
                  >
                    <div
                      *ngIf="createTrainingForm.controls['description'].errors?.['description']"
                    >
                      {{ "Description is required" | translator }}
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <label
                    class="block text-900 font-medium mb-2 font-bold"
                    for="houseNumber"
                    >{{ "Photo of the training program" | translator }}</label
                  >
                  <div class="d-flex justify-content-center">
                    <img
                      [hidden]="trainingImage == ''"
                      class="course-img"
                      [src]="GlobalConstants.staticFilesURL + trainingImage"
                    />
                  </div>
                  <p-fileUpload
                    class="my-2"
                    mode="basic"
                    name="file"
                    [url]="apilink + 'file/data'"
                    [auto]="true"
                    chooseLabel="{{ 'Add image' | translator }}"
                    accept="image/*"
                    [maxFileSize]="1000000000"
                    (onUpload)="trainingImage = $event.originalEvent.body.data"
                  ></p-fileUpload>
                </div>

                <p-divider align="left">
                  <div class="inline-flex align-items-center">
                    <i class="pi pi-calendar ml-2 mr-2"></i>
                    <b> {{ "Duration" | translator }} </b>
                  </div>
                </p-divider>

                <div class="col-lg-12">
                  <p-calendar
                    formControlName="timeline"
                    selectionMode="range"
                    [readonlyInput]="true"
                  ></p-calendar>
                </div>
              </div>
            </div>
          </form>
          <!-- End training creation form -->

          <!-- Add Session Form -->
          <form
            *ngIf="step.value == 2"
            [formGroup]="createSessionForm"
            (ngSubmit)="onSubmitSession()"
            novalidate
          >
            <!-- Session View -->
            <p-accordion [multiple]="true" [activeIndex]="[0]">
              <p-accordionTab *ngFor="let session of totalSessions">
                <ng-template
                  class="d-flex justify-content-between"
                  pTemplate="header"
                >
                  <div class="d-flex justify-content-between">
                    <div class="flex align-items-center mx-1">
                      <i class="pi pi-bookmark-fill mx-1"></i>
                      <span class="vertical-align-middle">{{
                        session.title
                      }}</span>
                    </div>
                    <div class="mx-1">
                      <span class="vertical-align-middle"
                        >({{ session.type }})</span
                      >
                    </div>
                  </div>
                </ng-template>
                <ng-template pTemplate="content">
                  <p-divider align="left">
                    <div class="inline-flex align-items-center">
                      <i class="pi pi-bookmark-fill ml-2 mr-2"></i>
                      <b> {{ "the details" | translator }} </b>
                    </div>
                  </p-divider>

                  <p class="m-0">
                    <span class="font-bold"
                      >{{ "the date" | translator }} :</span
                    >
                    {{ session.date | date }}
                  </p>
                  <p [hidden]="!session.start_time" class="m-0">
                    <span class="font-bold"
                      >{{ "Starting time" | translator }} :</span
                    >
                    {{ session.start_time }}
                  </p>
                  <p [hidden]="!session.end_time" class="m-0">
                    <span class="font-bold"
                      >{{ "end time" | translator }} :</span
                    >
                    {{ session.end_time }}
                  </p>

                  <!-- for course -->
                  <section *ngIf="session.type == 'COURSE'">
                    <app-view-course-details
                      [data]="session.typeId"
                    ></app-view-course-details>
                  </section>
                  <!-- End for course -->

                  <!-- for Assessment -->
                  <section *ngIf="session.type == 'ASSESSMENT'">
                    <p-divider align="left">
                      <div class="inline-flex align-items-center">
                        <i class="pi pi-book ml-2 mr-2"></i>
                        <b> {{ "Test details" | translator }} </b>
                      </div>
                    </p-divider>
                    <h3>{{ session.typeId.assessmentTitle }}</h3>
                    <h5>
                      <span class="font-bold"
                        >{{ "Test type" | translator }} :</span
                      >
                      {{ session.typeId.assessmentType }}
                    </h5>
                    <p>
                      <span class="font-bold"
                        >{{ "the description" | translator }} :</span
                      >
                      {{ session.typeId.description }}
                    </p>
                  </section>
                  <!-- End for course -->

                  <!-- for course -->
                  <section *ngIf="session.type == 'SURVEY'">
                    <p-divider align="left">
                      <div class="inline-flex align-items-center">
                        <i class="pi pi-chart-line ml-2 mr-2"></i>
                        <b> {{ "Survey details" | translator }} </b>
                      </div>
                    </p-divider>
                    <h3>{{ session.typeId.surveyTitle }}</h3>
                    <h5>
                      <span class="font-bold"
                        >{{ "Poll type" | translator }} :</span
                      >{{ session.typeId.surveyType }}
                    </h5>
                    <p>
                      <span class="font-bold"
                        >{{ "the description" | translator }} :</span
                      >
                      {{ session.typeId.description }}
                    </p>
                  </section>
                  <!-- End for course -->

                  <!-- for Program -->
                  <section *ngIf="session.type == 'PROGRAM'">
                    <h4>Trainer : {{ session.typeId.trainer.name }}</h4>
                    <div *ngIf="session.typeId.is_online; else elseBlock">
                      <p>Course will be conducted Online</p>
                    </div>
                    <ng-template #elseBlock>
                      <p-divider align="left">
                        <div class="inline-flex align-items-center">
                          <i class="pi pi-map-marker ml-2 mr-2"></i>
                          <b> Address </b>
                        </div>
                      </p-divider>
                      <p>
                        <span class="font-bold">Number :</span>
                        {{ session.typeId.houseNumber }}
                      </p>
                      <p>
                        <span class="font-bold">Street :</span>
                        {{ session.typeId.street }}
                      </p>
                      <p>
                        <span class="font-bold">City :</span>
                        {{ session.typeId.city }}
                      </p>
                    </ng-template>
                  </section>
                  <!-- End for course -->
                </ng-template>
              </p-accordionTab>
            </p-accordion>
            <!-- End Session View -->

            <div class="card-scroll">
              <div class="row">
                <div class="col-lg-12">
                  <label
                    class="block text-900 font-medium mb-2 font-bold"
                    for="title"
                    >{{ "the address" | translator }}</label
                  >
                  <input
                    type="text"
                    id="title"
                    placeholder="{{ 'Please write the address' | translator }}"
                    formControlName="title"
                    pInputText
                    class="w-full mb-3"
                  />
                  <div
                    class="error"
                    *ngIf="
                      createSessionForm.controls['title'].invalid &&
                      (createSessionForm.controls['title'].dirty ||
                        createSessionForm.controls['title'].touched)
                    "
                  >
                    <div
                      *ngIf="createSessionForm.controls['title'].errors?.['required']"
                    >
                      {{ "The title is required" | translator }}
                    </div>
                  </div>
                </div>

                <div class="col-lg-12">
                  <label
                    class="block text-900 font-medium mb-2 font-bold"
                    for="type"
                    >{{ "Type" | translator }}
                  </label>
                  <p-dropdown
                    (onChange)="selectSessionTypeID($event.value)"
                    id="city"
                    [options]="sessionTypes"
                    placeholder="{{ 'Please select the type' | translator }}"
                    formControlName="type"
                    styleClass=" sstarabic w-100"
                  >
                    <ng-template let-item pTemplate="item">
                      <i [ngClass]="item.icon"></i>
                      {{ item.label }}
                    </ng-template>
                  </p-dropdown>
                </div>

                <p-divider align="left">
                  <div class="inline-flex align-items-center">
                    <i class="pi pi-user ml-2 mr-2"></i>
                    <b> {{ "Duration" | translator }} </b>
                  </div>
                </p-divider>

                <div class="col-lg-12">
                  <p-calendar formControlName="date"></p-calendar>
                </div>

                <div
                  class="col-lg-6"
                  *ngIf="createSessionForm.get('type').value != 'COURSE'"
                >
                  <label
                    class="block text-900 font-medium mb-2 font-bold"
                    for="start_time"
                    >{{ "Starting time" | translator }}</label
                  >
                  <input
                    type="time"
                    id="start_time"
                    placeholder="{{
                      'Please select a start time' | translator
                    }}"
                    formControlName="start_time"
                    pInputText
                    class="w-full mb-3"
                  />
                  <div
                    class="error"
                    *ngIf="
                      createSessionForm.controls['start_time'].invalid &&
                      (createSessionForm.controls['start_time'].dirty ||
                        createSessionForm.controls['start_time'].touched)
                    "
                  >
                    <div
                      *ngIf="createSessionForm.controls['start_time'].errors?.['required']"
                    >
                      {{ "The start time is required" | translator }}
                    </div>
                  </div>
                </div>

                <div
                  class="col-lg-6"
                  *ngIf="createSessionForm.get('type').value != 'COURSE'"
                >
                  <label
                    class="block text-900 font-medium mb-2 font-bold"
                    for="end time"
                    >{{ "end time" | translator }}</label
                  >
                  <input
                    type="time"
                    id="end_time"
                    placeholder="{{ 'Please select an end time' | translator }}"
                    formControlName="end_time"
                    pInputText
                    class="w-full mb-3"
                  />
                  <div
                    class="error"
                    *ngIf="
                      createSessionForm.controls['end_time'].invalid &&
                      (createSessionForm.controls['end_time'].dirty ||
                        createSessionForm.controls['end_time'].touched)
                    "
                  >
                    <div
                      *ngIf="createSessionForm.controls['end_time'].errors?.['required']"
                    >
                      {{ "Completion time required" | translator }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <span>
              <div class="d-flex justify-content-center">
                <button
                  type="submit"
                  [disabled]="!createSessionForm.valid"
                  (click)="onSubmitSession()"
                  pButton
                  pRipple
                  label=" {{ 'construction' | translator }}"
                  icon="pi pi-user-edit"
                  class="w-50 mb-5"
                ></button>
              </div>
            </span>
          </form>

          <!-- review Section -->
          <section *ngIf="step.value == 3">
            <app-view-training-details
              [data]="completeTrainingObject"
            ></app-view-training-details>
          </section>
          <!-- End review Section -->

          <!-- review Section -->
          <section *ngIf="step.value == 4">
            <p>
              A new training program has been developed, designed to enhance
              skills and knowledge. It's ready for your approval, reflecting our
              dedication to offering valuable learning experiences tailored to
              industry trends and individual needs. Your review will help ensure
              its quality and effectiveness.
            </p>
          </section>
          <!-- End review Section -->

          <!-- End add Session Form -->
          <p *ngIf="message" class="message">{{ message }}</p>
          <span>
            <button
              [hidden]="step.value >= 3"
              type="button"
              (click)="constructCompleteTrainingObject()"
              [disabled]="!createTrainingForm.valid || trainingImage == ''"
              pButton
              pRipple
              label=" {{ 'the next' | translator }} "
              icon="pi pi-angle-double-left"
              class="w-full my-2"
            ></button>
          </span>
          <span>
            <button
              *ngIf="step.value == 4"
              type="button"
              (click)="reload()"
              [disabled]="!createTrainingForm.valid"
              pButton
              pRipple
              label="{{ 'Exit' | translator }}"
              icon="pi pi-check"
              class="w-full my-2"
            ></button>
          </span>
          <span>
            <button
              [hidden]="step.value != 3"
              type="submit"
              [disabled]="!createTrainingForm.valid"
              (click)="onSubmit()"
              pButton
              pRipple
              label=" {{ 'OK' | translator }} "
              icon="pi pi-pencil"
              class="w-full"
            ></button>
          </span>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Course Selection Modal -->
<p-dialog
  [blockScroll]="true"
  [draggable]="false"
  header="Select Course"
  [(visible)]="openCourseModal"
  [style]="{ width: '90vw' }"
  [maximizable]="true"
>
  <div class="row">
    <p-card
      class="col-4 col-lg-6 col-md-6 my-3"
      *ngFor="let course of courses"
      [header]="course?.title"
    >
      <ng-template pTemplate="header">
        <div class="img-card-view">
          <img
            class="img-response"
            alt="Card"
            [src]="GlobalConstants.staticFilesURL + course.image"
          />
        </div>
      </ng-template>
      <div class="flex-column">
        <span class="description-responsive">
          <span class="desc-heading">{{ "the description" | translator }}</span>
          <span [innerHTML]="course?.description | safeHTML"></span>
        </span>
      </div>
      <ng-template pTemplate="footer">
        <p-button
          label="{{ 'Choose' | translator }}"
          (onClick)="sectionTypeIdHolder = course; openCourseModal = false"
          icon="pi pi-check"
        ></p-button>
      </ng-template>
    </p-card>
  </div>
</p-dialog>
<!-- End Course Selection Modal -->

<!-- Assessment Selection Modal -->
<p-dialog
  [blockScroll]="true"
  [draggable]="false"
  header="{{ 'Choose a test' | translator }}"
  [(visible)]="openAssessmentModal"
  [style]="{ width: '50vw' }"
  [maximizable]="true"
>
  <div class="row">
    <p-card
      div
      class="col-12"
      *ngFor="let assessment of assessments"
      [header]="assessment.assessmentTitle"
      [subheader]="assessment.assessmentType"
    >
      <p>
        {{ assessment.description }}
      </p>
      <ng-template pTemplate="footer">
        <p-button
          label="{{ 'Choose' | translator }}"
          (onClick)="
            sectionTypeIdHolder = assessment; openAssessmentModal = false
          "
          icon="pi pi-check"
        ></p-button>
      </ng-template>
    </p-card>
  </div>
</p-dialog>
<!-- End Assessment Selection Modal -->

<!-- Survey Selection Modal -->
<p-dialog
  [blockScroll]="true"
  [draggable]="false"
  header="{{ 'Choose a poll' | translator }} "
  [(visible)]="openSurveyModal"
  [style]="{ width: '50vw' }"
  [maximizable]="true"
>
  <div class="row">
    <p-card
      class="col-12"
      *ngFor="let survey of surveys"
      [header]="survey.surveyTitle"
      [subheader]="survey?.surveyTitle"
    >
      <p>
        {{ survey?.description }}
      </p>
      <ng-template pTemplate="footer">
        <p-button
          label="{{ 'Choose' | translator }}"
          (onClick)="sectionTypeIdHolder = survey; openSurveyModal = false"
          icon="pi pi-check"
        ></p-button>
      </ng-template>
    </p-card>
  </div>
</p-dialog>
<!-- End Survey Selection Modal -->

<!-- Program Selection Modal -->
<p-dialog
  [blockScroll]="true"
  [draggable]="false"
  header="Create program"
  [(visible)]="openProgramModal"
  [style]="{ width: '50vw', minHeight: '40vh' }"
  [maximizable]="true"
>
  <form
    class="custom-bg-1 h-380px"
    [formGroup]="createProgramForm"
    (ngSubmit)="onSubmitProgram()"
    novalidate
  >
    <div class="card-scroll">
      <div class="row">
        <div class="col-9">
          <label class="block text-900 font-medium mb-2 font-bold" for="trainer"
            >Trainer</label
          >
          <p-dropdown
            styleClass="w-100"
            [options]="trainers"
            formControlName="trainer"
            optionLabel="name"
            [filter]="true"
            filterBy="name"
            [showClear]="true"
            placeholder="Select a trainer"
          >
            <!-- <ng-template pTemplate="selectedItem">
                            <div class="flex align-items-center gap-2" *ngIf="selectedCountry">
                                <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" [class]="'flag flag-' + selectedCountry.code.toLowerCase()" style="width: 18px"/>
                                <div>{{ selectedCountry.name }}</div>
                            </div>
                        </ng-template> -->
            <ng-template let-trainers pTemplate="item">
              <div class="flex align-items-center gap-2">
                <!-- <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png" [class]="'flag flag-' + country.code.toLowerCase()" style="width: 18px"/> -->
                <div>{{ trainers.name }}</div>
              </div>
            </ng-template>
          </p-dropdown>
          <div
            class="error"
            *ngIf="
              createProgramForm.controls['trainer'].invalid &&
              (createProgramForm.controls['trainer'].dirty ||
                createProgramForm.controls['trainer'].touched)
            "
          >
            <div
              *ngIf="createProgramForm.controls['trainer'].errors?.['required']"
            >
              Title Required
            </div>
            <!-- <div *ngIf="createProgramForm.controls['title'].errors?.['pattern']">{{"Please write in Arabic"| translator}}</div> -->
          </div>
        </div>
        <div class="col-3">
          <label class="block text-900 font-medium mb-2 font-bold" for="trainer"
            >is online</label
          >
          <p-checkbox
            formControlName="is_online"
            [binary]="true"
            inputId="binary"
          ></p-checkbox>
        </div>
        <section *ngIf="!createProgramForm.get('is_online').value">
          <p-divider align="left">
            <div class="inline-flex align-items-center">
              <i class="pi pi-map-marker ml-2 mr-2"></i>
              <b> Address </b>
            </div>
          </p-divider>

          <div class="col-12">
            <label
              class="block text-900 font-medium mb-2 font-bold"
              for="houseNumber"
              >House Number</label
            >
            <input
              styleClass="w-100"
              class="w-100"
              type="text"
              id="houseNumber"
              placeholder="Enter House Number"
              formControlName="houseNumber"
              pInputText
              class="w-full mb-3"
            />
            <div
              class="error"
              *ngIf="
                createProgramForm.controls['houseNumber'].invalid &&
                (createProgramForm.controls['houseNumber'].dirty ||
                  createProgramForm.controls['houseNumber'].touched)
              "
            >
              <div
                *ngIf="createProgramForm.controls['houseNumber'].errors?.['required']"
              >
                {{ "The name is required" | translator }}
              </div>
              <!-- <div *ngIf="createProgramForm.controls['houseNumber'].errors?.['pattern']">{{"Please write in Arabic"| translator}}</div> -->
            </div>
          </div>
          <!-- pattern="[\u0600-\u06FF\s]+" -->
          <div class="col-12">
            <label class="block text-900 font-medium mb-2 font-bold" for=""
              >Street</label
            >
            <input
              styleClass="w-100"
              type="text"
              id="street"
              placeholder="Enter Street"
              formControlName="street"
              pInputText
              class="w-full mb-3"
            />
            <div
              class="error"
              *ngIf="
                createProgramForm.controls['street'].invalid &&
                (createProgramForm.controls['street'].dirty ||
                  createProgramForm.controls['street'].touched)
              "
            >
              <div
                *ngIf="createProgramForm.controls['street'].errors?.['required']"
              >
                street Requires
              </div>
              <!-- <div *ngIf="createProgramForm.controls['street'].errors?.['pattern']">{{"Please write in Arabic"| translator}}</div> -->
            </div>
          </div>

          <div class="col-lg-12">
            <label class="block text-900 font-medium mb-2 font-bold" for="city"
              >{{ "City" | translator }}
            </label>
            <p-dropdown
              id="city"
              [options]="city"
              placeholder="{{ 'Choose the city' | translator }}"
              formControlName="city"
              styleClass=" sstarabic w-100"
            >
              <ng-template let-item pTemplate="item">
                <i [ngClass]="item.icon"></i>
                {{ item.label }}
              </ng-template>
            </p-dropdown>
          </div>
        </section>
      </div>
    </div>
    <span>
      <button
        type="button"
        (click)="onSubmitProgram()"
        pButton
        pRipple
        [disabled]="!createProgramForm.valid"
        label=" Sumit "
        icon="pi pi-user-edit"
        class="w-full"
      ></button>
    </span>
  </form>
</p-dialog>
<!-- End Program Selection Modal -->
